import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import './styles/base.css'
import 'leaflet/dist/leaflet.css'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAuthStore } from '@/stores/auth'

const app = createApp(App)

// Errors only — empty VITE_SENTRY_DSN keeps the SDK fully disabled in dev.
Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  tracesSampleRate: 0,
  sendDefaultPii: false,
})

app.use(createPinia())

// Restore OIDC session before the router processes the first navigation.
// Without this, the router guard never sees an authenticated user on page reload.
const auth = useAuthStore()
await auth.init()

app.use(router)

app.mount('#app')
